import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

export interface DadosBancariosCancelamento {
  cdBanco: string | undefined;
  dsAgencia: string;
  dsConta: string;
  tpConta: string | undefined;
  dsEmail: string;
}

@Component({
  selector: 'app-cancelar-produto-modal-dados-bancarios',
  templateUrl: './cancelar-produto-modal-dados-bancarios.component.html',
  styleUrls: ['./cancelar-produto-modal-dados-bancarios.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class CancelarProdutoModalDadosBancariosComponent extends AbstractComponent implements OnInit {

  bancoList: any[] = [];

  tipoContaList: any[] = [
    { value: 'CORRENTE', label: 'CORRENTE' },
    { value: 'POUPANCA', label: 'POUPANÇA' }
  ];

  dadosTela: DadosBancariosCancelamento = {
    cdBanco: undefined,
    dsAgencia: '',
    dsConta: '',
    tpConta: undefined,
    dsEmail: ''
  };

  formDadosBancarios: FormGroup = new FormGroup({});

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialogRef: MatDialogRef<CancelarProdutoModalDadosBancariosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.dialogRef.disableClose = true;
    this.carregarListaBancos();

    this.formDadosBancarios = new FormGroup({
      cdBanco: new FormControl(this.dadosTela.cdBanco, [Validators.required, Validators.pattern('^[0-9]*$')]),
      dsAgencia: new FormControl(this.dadosTela.dsAgencia, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]),
      dsConta: new FormControl(this.dadosTela.dsConta, [Validators.required, Validators.pattern('^[0-9]{1,13}-[0-9a-zA-Z]$'), Validators.maxLength(15)]),
      tpConta: new FormControl(this.dadosTela.tpConta, [Validators.required]),
      dsEmail: new FormControl(this.dadosTela.dsEmail, [Validators.required, Validators.email, Validators.maxLength(70)])
    });
  }

  /**
   * Busca a lista de bancos para popular o campo de seleção
   */
  carregarListaBancos() {
    this.liquidacaoAntecipadaService.listarBanco().subscribe(
      (result: any) => {
        var data = result;
        var bancosTransformados = data.bancos.map((banco: any) => ({
          value: String(banco.cdBanco),
          label: banco.nmBanco.trim()
        }));
        this.bancoList = bancosTransformados;
      },
      (error: Response) => {
        // Mesmo em caso de erro, o formulário permanece disponível para preenchimento manual dos demais campos
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      });
  }

  onBlurGenerico(event: any, campo: string) {
    const value = event;
    let valorMascarado = value;

    if (campo === 'BANCO') {
      this.dadosTela.cdBanco = value;
      this.atualizarFormulario();
      return;
    } else if (campo === 'TIPO_CONTA') {
      this.dadosTela.tpConta = value;
      this.atualizarFormulario();
      return;
    } else if (campo === 'AGENCIA') {
      valorMascarado = value.replace(/\D/g, '').slice(0, 5); // Remove caracteres não numéricos e limita a 5 dígitos
    } else if (campo === 'CONTA') {
      const numeros = value.replace(/-/g, '').slice(0, 14); // Remove o hífen e limita a 14 dígitos
      if (numeros.length > 1) {
        valorMascarado = numeros.slice(0, -1) + '-' + numeros.slice(-1); // Formata como 99999-9
      } else {
        valorMascarado = numeros;
      }
    } else if (campo === 'EMAIL') {
      valorMascarado = value;
    }

    if (campo === 'AGENCIA') {
      this.dadosTela.dsAgencia = valorMascarado;
    } else if (campo === 'CONTA') {
      this.dadosTela.dsConta = valorMascarado;
    } else if (campo === 'EMAIL') {
      this.dadosTela.dsEmail = valorMascarado;
    }

    this.atualizarFormulario();
  }

  atualizarFormulario() {
    this.formDadosBancarios.patchValue({
      cdBanco: this.dadosTela.cdBanco,
      dsAgencia: this.dadosTela.dsAgencia,
      dsConta: this.dadosTela.dsConta,
      tpConta: this.dadosTela.tpConta,
      dsEmail: this.dadosTela.dsEmail
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    formGroup.markAsTouched({ onlySelf: true });
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control) {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  confirmar() {
    if (this.formDadosBancarios.valid) {
      this.dialogRef.close(this.dadosTela);
    } else {
      this.markFormGroupTouched(this.formDadosBancarios);
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-cancelarproduto-cli/cancelar-produto-modal-dados-bancarios.component.ts